import React, { useState } from 'react'
import { motion } from 'framer-motion'
import { IoChevronDownOutline, IoChevronUpOutline } from 'react-icons/io5';

function Accordion({ children, title }) {

    const [isOpen, setIsOpen] = useState(false);

    const handleOpen = () => {
        setIsOpen(!isOpen)
    }

    return (
        <div className='w-full bg-containerBg p-3 rounded-lg shadow shadow-black/5'>
            {/* Head */}
            <div className="cursor-pointer flex items-center w-full justify-between" onClick={handleOpen}>
                <h3 className='font-semibold font-serif'>{title}</h3>
                <button onClick={handleOpen} className='w-10 h-10 shadow bg-white rounded-full flex justify-center items-center'>
                    {isOpen ? <IoChevronUpOutline /> : <IoChevronDownOutline />}
                </button>
            </div>
            {/* Body */}
            <motion.div
                className='overflow-hidden'
                initial={{ height: 0 }}
                animate={{ height: isOpen ? 'auto' : 0 }}
            >
                {children}
            </motion.div>
        </div>
    )
}

export default Accordion